import {
  TfgSettingsPutDto,
  TfgSettingsWebDto,
} from '@/features/dashboard/tfg/types/TfgSettingsDto.ts';
import { isFlightType } from '@/features/dashboard/tfg/types/UfgTransportType.utils.ts';
import { TransportVariantDto } from '@/features/dashboard/tourTransport/types/TransportConfigurationDto.ts';
import {
  TransportFormData,
  TransportInputForm,
} from '@/features/dashboard/tourTransport/schemas/transportSchema.ts';

export const tfgSettingsMapper = {
  /**
   * Overlays the TFG settings onto an already-built transport form:
   * - territory pre-fills from suggestedTerritory when not yet saved,
   * - each variant's ufgTransportType / airportCode are matched by variantId.
   */
  applyToForm(
    base: TransportInputForm,
    dto: TfgSettingsWebDto,
  ): TransportInputForm {
    const typingByVariantId = new Map(
      dto.variantTypings.map((typing) => [typing.variantId, typing]),
    );

    return {
      ...base,
      territory: dto.territory ?? dto.suggestedTerritory ?? undefined,
      variants: base.variants.map((variant) => {
        const typing = variant.id
          ? typingByVariantId.get(variant.id)
          : undefined;
        return {
          ...variant,
          ufgTransportType: typing?.ufgTransportType,
          airportCode: typing?.airportCode,
        };
      }),
    };
  },

  /**
   * Builds the tfg-settings PUT body. The transport PUT must run first so every
   * variant has a backend id; we zip those ids with the form's per-variant
   * typings by position (the transport endpoint returns variants in submitted
   * order — the transport mapper already relies on this).
   */
  buildPutDto(
    form: TransportFormData,
    savedVariants: TransportVariantDto[],
  ): TfgSettingsPutDto {
    return {
      territory: form.territory!,
      variantTypings: savedVariants.map((variant, index) => {
        const formVariant = form.variants[index];
        const ufgTransportType = formVariant.ufgTransportType!;
        return {
          variantId: variant.id!,
          ufgTransportType,
          ...(isFlightType(ufgTransportType)
            ? { airportCode: formVariant.airportCode }
            : {}),
        };
      }),
    };
  },
};
